const BANK_REFERRAL_BOTTOMSHEET = {
  dataAid: "enterReferral",
  title: {
    text: "Have a bank referral code?",
    dataAid: "referralCode",
  },
  input: {
    label: "Enter code here",
    dataAid: "referralCode",
  },
  primaryButtonTitle: {
    text: 'continue',
    dataAid: "primary",
  },
  secondaryButtonTitle: {
    text: 'Don’t have a code',
    dataAid: "secondary",
  },
};

const EDIT_FUNDS = {
  iconDataAid: "edit",
  title: {
    text: "Funds",
    dataAid: "funds",
  },
  buttonText: {
    text: "Edit funds",
    dataAid: "edit",
  },
};

const RECOMMENDED_FUNDS = {
  dataAid: "recommendedFunds",
  header: {
    dataAid: "recommendedFunds",
    title: "Recommended funds",
  },
  riskProfileDataAid: "riskProfile",
  totalAmount: {
    title: {
      onetime: "Investment amount",
      sip: "Monthly SIP amount",
      dataAid: "amountKey",
    },
    amount: {
      dataAid: "amountValue",
    },
  },
  tnc: {
    dataAid: "termsAndConditions",
    checkboxDataAid: "left",
    leftText: "I accept the",
    tncText: " Terms & Privacy Policy ",
    rightText: "& agree to receive important investment updates on WhatsApp",
    trustIconDataAid: "secure",
  },
  footer: {
    text: "CONTINUE",
    dataAid: "primary",
  },
  editFunds: EDIT_FUNDS,
  bankReferralBottomsheet: BANK_REFERRAL_BOTTOMSHEET,
};

export default RECOMMENDED_FUNDS;
